import { configureStore, combineReducers } from "@reduxjs/toolkit";
import cartReducer from "./reducers/cartReducer";
import categoryReducer from "./reducers/categoryReducer";
import languageReducer from "./reducers/languageReducer";
import messageReducer from "./reducers/messageReducer";
import wishlistReducer from "./reducers/wishlistReducer";
import currencyReducer from "./reducers/currencyReducer";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import rootReducer from "./reducers";


//  Persist config
const persistConfig = {
    key: "root",
    storage,
    whitelist: ["cart", "language"],
};

//  Wrap rootReducer with persist
const persistedReducer = persistReducer(persistConfig, rootReducer);

//  Create store
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

//  Create persistor
export const persistor = persistStore(store);

export default store;
